/**
 * Is this article finished enough to be part of a feed result?
 *
 * The backend's answer is `phase === 'claimsClusteringComplete'`
 * (`FEED_ARTICLE_PHASE` in `backend/news_graph_utils.js`): every article-fetch
 * path in the story search requires it, and so now do the share-threshold and
 * restrictive-category denominators.
 *
 * The article page deliberately loads a WIDER set — it also returns
 * `subjectClustered` articles, which are clustered but have not finished claims
 * extraction. That is the right call for a reading surface, but it meant the
 * screen showed three articles while the filter had counted two, and an article
 * that was merely unfinished was labelled as though it had failed the filter.
 * A reviewer dividing the two numbers gets 66.7% and concludes an 80% threshold
 * is broken.
 *
 * So the two reasons an article is not a source are kept apart: it did not
 * match the filter, or it is not ready yet. Only the first is about the filter.
 *
 * Absent `phase` returns false — an older payload is treated as ready rather
 * than silently relabelling every article on the page.
 */

export const FEED_ARTICLE_PHASE = 'claimsClusteringComplete';

export function isAwaitingProcessing(article) {
  const phase = article?.phase;
  if (!phase) return false;
  return phase !== FEED_ARTICLE_PHASE;
}
